import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showWarningDialog } from "../../../redux/actions/warning";

const decodeWarningMessage = (message) => {
    if (typeof message !== "string") {
        return message;
    }

    const looksMojibake = /[ÃÂ�]/.test(message);

    if (!looksMojibake || typeof TextDecoder === "undefined") {
        return message;
    }

    try {
        const bytes = Uint8Array.from(message, (character) => character.charCodeAt(0));
        const decodedMessage = new TextDecoder("utf-8").decode(bytes);

        return decodedMessage || message;
    } catch {
        return message;
    }
};


const getWarningMessage = (response) => {
    const headers = response?.headers;

    return (
        headers?.get?.("x-mensaje-advertencia") ??
        headers?.["x-mensaje-advertencia"] ??
        headers?.["X-Mensaje-Advertencia"]
    );
};

const useWarningMessage = () => {

    const dispatch = useDispatch();

    useEffect(() => {

        const interceptor = axios.interceptors.response.use(
            (response) => {

                const warningMessage = decodeWarningMessage(getWarningMessage(response));

                if (typeof warningMessage === "string" && warningMessage.trim()) {
                    dispatch(showWarningDialog(warningMessage.trim()));
                }

                return response;
            },
            (error) => {
                const warningMessage = decodeWarningMessage(getWarningMessage(error?.response));

                if (typeof warningMessage === "string" && warningMessage.trim()) {
                    dispatch(showWarningDialog(warningMessage.trim()));
                }

                return Promise.reject(error);
            }
        )

        return () => {
            axios.interceptors.response.eject(interceptor);
        }
    }, [dispatch]);

    return;
};

export default useWarningMessage;